import L from 'leaflet';

L.Control.include({
    _stopContainerEvents: function() {
        const container = this._container;
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);
        L.DomEvent.on(container, 'mousemove contextmenu', L.DomEvent.stop);

    }
});



/** WEBPACK FOOTER **
 ** ./src/lib/leaflet.control.commons/index.js
 **/